import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export class TimeRangeInput {
    von: Date;
    bis: Date;
}

export class TimeRangeOutput {
    ok: boolean;
    confirmed: boolean;
    von: Date;
    bis: Date;
}

@Component({
    selector: 'kiene-time-range-auswahl-dialog',
    templateUrl: './time-range-auswahl-dialog.component.html',
    styleUrls: ['./time-range-auswahl-dialog.component.scss'],
})
export class TimeRangeAuswahlDialogComponent implements OnInit {
    public vonCtrl: FormControl = new FormControl(undefined, [Validators.required]);
    public bisCtrl: FormControl = new FormControl(undefined, [Validators.required]);

    constructor(
        public dialogRef: MatDialogRef<TimeRangeAuswahlDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TimeRangeInput,
    ) {}

    ngOnInit(): void {
        if (this.data?.von) {
            this.vonCtrl.setValue(this.data.von);
        }
        if (this.data?.bis) {
            this.bisCtrl.setValue(this.data.bis);
        }
    }

    save() {
        const result = new TimeRangeOutput();
        result.ok = true;
        result.confirmed = true;
        result.von = this.vonCtrl.value;
        result.bis = this.bisCtrl.value;
        this.dialogRef.close(result);
    }

    public cancel(): void {
        const result = new TimeRangeOutput();
        result.ok = true;
        this.dialogRef.close(result);
    }
}
